import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
export default function NeckPainServiceBox() {
  return <Card className="border-border shadow-soft hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] px-6">
      <CardHeader>
        <CardTitle className="text-2xl font-display text-primary"><br /></CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-muted-foreground leading-relaxed"><br /></p>
      </CardContent>
      <CardFooter className="flex gap-3">
        <Link to="/ServicesPage">
          
        </Link>
        <Link to="/ContactPage">
          
        </Link>
      </CardFooter>
    </Card>;
}